module.exports = __webpack_public_path__ + "img/home_city_icon4.4563c10.png";